
  <mat-toolbar *ngIf="measureView=='before-measuring'" class="custom-toolbar">
    <button mat-icon-button class="white-icon" aria-label="back clicked" (click)="backClicked()">
      <mat-icon class="volume-icon">arrow_back</mat-icon>
    </button>
    <span class="toolbar-title">Measure Soil Moisture</span>
    <span class="toolbar-spacer"></span>
    <button mat-icon-button class="white-icon" aria-label="read text" (click)="volumeClicked()">
      <mat-icon>volume_up</mat-icon>
    </button>
  </mat-toolbar>

  <div *ngIf="measureView=='before-measuring'" class="content-container" >
    <swiper *ngIf="measureView=='before-measuring'" #swiper class="swiper-container" [config]="config" [(index)]="curIndex" [disabled]="disabled"
            (indexChange)="onIndexChange($event)" (swiperTransitionStart)="onSwiperEvent('transitionStart')"
            (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">

          <div class="swiper-slide">
            <div class="container" fxLayout="column" fxFlexFill fxLayoutAlign="end center" >
              <div class="container text-area" fxLayout="column" fxFlexWrap fxLayoutAlign="start center" >
                <p class="title" >Step 1</p>
                <p class="description">Get your sensor Ready</p>
              </div>
              <img mat-card-image class="cardImg" src="assets/measure-guide/graphic-1.png" alt="Step 1:">
            </div>
          </div>

          <div class="swiper-slide">
            <div class="container" fxLayout="column" fxFlexFill fxLayoutAlign="end center" >
              <div class="container text-area"  fxLayout="column" fxFlexWrap fxLayoutAlign="start center" >
                <p class="title" textWrap="true">Step 2</p>
                <label class="description">Insert the sensor at least 15 cm deep</label>
              </div>
              <img mat-card-image class="cardImg" src="assets/measure-guide/graphic-2.png" alt="Step 2:">
            </div>
          </div>

          <div class="swiper-slide">
            <div class="container" fxLayout="column" fxFlexFill fxLayoutAlign="end center" >
              <div class="container text-area sensor-text" fxLayout="column" fxFlexWrap fxLayoutAlign="start center">
                <p class="title" textWrap="true">Step 3</p>
                <p class="description" flex textWrap="false">Connect to Sensor</p>
                <button mat-flat-button class="c-btn" (click)="onSensorConnect('wifi')"><mat-icon>wifi</mat-icon> Update WiFi Channel</button>
                <button mat-flat-button class="c-btn" (click)="onSensorConnect('calibrate')"><mat-icon>usb</mat-icon> Calibrate Sensor</button>
                <button mat-flat-button class="c-btn" (click)="onSensorConnect('ble')"><mat-icon>bluetooth</mat-icon> Connect with Bluetooth </button>
                <button mat-flat-button class="c-btn" (click)="onSensorConnect('ble_name')"><mat-icon>bluetooth</mat-icon> Rename Sensor  </button>
                <button mat-flat-button class="c-btn" (click)="onSensorConnect('ble_off')"><mat-icon>bluetooth</mat-icon> Turn off Bluetooth  </button>
                <button mat-flat-button class="c-btn" (click)="onSensorConnect('input_pin')"><mat-icon>bluetooth</mat-icon> Change Sensor Pin  </button>
              </div>
              <img mat-card-image class="cardImg" src="assets/measure-guide/graphic-3.png" alt="Connect to Sensor" />
            </div>
          </div>
    </swiper>

  </div>

  <div *ngIf="measureView=='measuring'"
       fxFlexFill fxLayout="column"
       fxLayoutGap="25px"
       fxLayoutAlign="center center">
      <div>
        <mat-spinner diameter="100" color="primary"></mat-spinner>
        <div style="position:relative; top: -60px; left: 45px;">{{countdownSecond}}</div>
      </div>
      <p>Reading...</p>
  </div>

  <div *ngIf="measureView=='after-measuring'"
       fxFlexFill fxLayout="column"
       fxLayoutGap="28px"
       fxLayoutAlign="center center">
    <img [src]="moistureIcon" alt="low-moisture" height="160px" width="160px">
    <p class="mat-body-1">SOIL MOISTURE</p>
    <p class="mat-display-1">
      <span [class]="soilMoistureColorClass">{{ soilData.soilMoistureIndex }} </span>
      <span> {{soilData.soilMoisturePercentage}}% </span>
    </p>
    <button mat-flat-button color="primary" (click)="onGetAdvise()">GET ADVICE</button>
  </div>

  <mat-toolbar *ngIf="measureView=='before-measuring'" class="toolbarNav">

    <div class="container" fxLayout="row" fxFlexFill fxLayoutAlign="space-between center" >

        <button [ngClass]="{'invisible': isFirstSlide}" mat-icon-button style="margin-right: 24px">
          <mat-icon class="blue-icon" (click)="onSlideNav('back')">navigate_before</mat-icon>
          <span Class="tool-bar-text" (click)="onSlideNav('back')">BACK  </span>
        </button>

        <app-slide-indicator [current]="curIndex" [length]="3"></app-slide-indicator>

        <button [ngClass]="{'invisible': isLastSlide}" mat-icon-button style="margin-right: 24px">
          <span Class="tool-bar-text" (click)="onSlideNav('next')">NEXT</span>
          <mat-icon class="blue-icon" (click)="onSlideNav('next')">navigate_next</mat-icon>
        </button>

    </div>
  </mat-toolbar>
